import { useRouter } from "next/router";
import { useEffect } from "react";

export function ScrollToTop() {
  const router = useRouter();
  const { pathname } = router;

  useEffect(() => {
    document.querySelector("#layout").scrollTo(0, 0);
  }, [pathname]);

  return null;
}
